module.exports = __webpack_public_path__ + "img/8.d37d1e76.jpg";